import ErrorIcon from '@mui/icons-material/Error';
import { Button, Dialog, DialogContent } from '@mui/material';

interface IFileValidationErrorModalProps {
  open: boolean;
  message: string;
  onClose: () => void;
}

const FileValidationErrorModal = ({ open, message, onClose }: IFileValidationErrorModalProps) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          height: '200px',
          width: '100%',
          borderRadius: 'lg',
        }}
      >
        <ErrorIcon sx={{ color: '#f95838', fontSize: '40px' }} />
        <span className='mt-5 text-[#1b4332] text-md font-[Plus Jakarta Sans] font-medium'>{message}</span>
        <Button color='inherit' variant='outlined' sx={{ marginTop: '25px' }} onClick={onClose}>
          Close
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default FileValidationErrorModal;
